<template>
    <div>
        <div class="mvt-feed section" v-if="active">
            <h3>
                <b class="f3 text-bold">{{isNotification ? 'Notification' : 'Feed'}}</b>
                <a class="feed-toggle" @click="toggleAll" v-if="isNotification ">
                    <span v-if="allDisabled">
                        <i class="icon-toggle-off" ></i> Enable All
                    </span>
                    <span v-else>
                        <i class="icon-toggle-on"></i> Disable All
                    </span>
                </a>
            </h3>
            <span v-if="getData&&getData.length">
                <div class="mvt-feed-filter" >
                    <a v-for="(item,i) in getData" class="text-uppercase btn secondary small ca" :class="{active: index ===i}" @click="refresh(i)">{{ item.zipcode + ', ' + item.stateCode}}</a>
                </div>
                <div class="mvt-feed-edit" :class="{'edit':edit}">
                    <div class="mvt-feed-edit-body">
                        <div class="grid panel">
                            <div v-if="selectedItem.propertyType">
                                <mvtCheckbox class="small" :data="propertyTypeData" v-model="selectedItem.propertyType"></mvtCheckbox>
                            </div>
                            <div>
                                <mvtRadio class="small" :data="bedroomData" v-model="selectedItem.minBed"></mvtRadio>
                            </div>
                            <div>
                                <div class="input small">
                                    <label>Max Price</label>
                                    <mvtInputCurrency v-model="selectedItem.maxPrice" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mvt-feed-edit-footer">
                        <div>Date Updated: {{$filters.formatFriendlyDate(selectedItem.updateTime)}}</div>
                        <div>
                        <span v-if="isNotification">
                            <a class="toggle" @click="toggle" >
                                <span v-if="selectedItem.disabled">
                                    <i class="icon-toggle-off"></i> Enable
                                </span>
                                <span v-else>
                                    <i class="icon-toggle-on" ></i> Disable
                                </span>
                            </a>
                            <a @click="deleteSelectedNotification">
                                <i class="icon-trash"></i> Delete
                            </a>
                        </span>
                        <span v-else>
                            <a @click="deleteSelectedFeed">
                                <i class="icon-trash"></i> Delete
                            </a>
                        </span>
                        <a class="link" v-if="!edit" @click="toogleEdit"><i class="icon-pencil"></i> Edit</a>
                        <a class="link" v-if="edit" @click="saveFeed"><i class="icon-check"></i> Update</a>
                        <a class="link" v-if="list && list.length" @click="saveFeedToEmail">Get Email Notifications</a>
                        </div>
                    </div>
                </div>
                <div class="mvt-feed-list">
                    <div class="grid panel" v-if="list && list.length">
                        <mvtCardProperty :data="item"  v-for="item in list" :key="item.propertyId"></mvtCardProperty>
                    </div>
                    <div class="panel" v-else>
                        No matched House in this feed. Please update the filter and click the "<i class="icon-check"></i> Update" try again.
                    </div>
                </div>
            </span>
            <span v-else>
                <div class="panel">
                    Visit some properties to see {{isNotification ? 'notification' : 'feed'}}.
                </div>
            </span>
        </div>
    </div>
</template>
<script src="./mvt-feed.js"></script>
<style lang="scss">
    @use "./mvt-feed.scss" as *;
</style>